// Import CSS for Rollup PostCSS processing
import '../css/index.css';

// Shared tag lookup tables (geoRoutes, prdRoutes) — exposed as window.PSA.tagMaps
// Must be imported before any badge partial scripts run.
import './tag-maps.js';

// Post and Card Badging logic (GEO / PRD routes)
import './badge-engine.js';

// Channel logic engine (sort/filter/API and component sync)
import './channel-engine.js';

// ---- Mobile Menu Toggle ----
document.addEventListener('DOMContentLoaded', () => {
    const burger = document.querySelector('.gh-burger');
    const mobileMenu = document.querySelector('.gh-mobile-menu');

    if (burger && mobileMenu) {
        burger.addEventListener('click', () => {
            mobileMenu.classList.toggle('hidden');
            // Toggle aria-expanded for accessibility
            const expanded = burger.getAttribute('aria-expanded') === 'true';
            burger.setAttribute('aria-expanded', String(!expanded));
        });
    }
});

// ---- Gallery Image Sizing ----
document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach((image) => {
        const container = image.closest('.kg-gallery-image');
        if (container && image.naturalWidth && image.naturalHeight) {
            const ratio = image.naturalWidth / image.naturalHeight;
            container.style.flex = `${ratio} 1 0%`;
        }
    });
});

// Ghost Admin Components (staff edit button, public/member view toggle)
import './admin-components.js';

// Ask an Analyst Modal Feature
import './ask-analyst.js';
